__turbopack_context__.v({
  "cards": "MoreInSports-module-scss-module__WOumUW__cards",
  "moreInSports": "MoreInSports-module-scss-module__WOumUW__moreInSports",
  "title": "MoreInSports-module-scss-module__WOumUW__title",
});
